import React, { useState } from "react";
import "./navbar.css";
import logo from "../Assests/logo.png";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="navbar-main">
      <div className="navbar-container">
        {/* Logo Section */}
        <div className="navbar-logo">
          <Link to="/"> <img src={logo} alt="logo" /></Link>
        </div>

        {/* Desktop Navigation Links */}
        <nav className="navbar-links">
          <ul>
            <li><Link to="/product">PRODUCT'S</Link></li>
            <li><Link to="/about">ABOUT</Link></li>
            <li><Link to="/contact">CONTACT</Link></li>
            <li><Link to="/career">CAREER</Link></li>
          </ul>
        </nav>

        {/* Button on the right */}
        <div className="navbar-button">
          <Link to="/be-partner">BE A PARTNER</Link>
        </div>

        {/* Menu Icon for Mobile */}
        <div className="menu-icon" onClick={() => setIsOpen(true)}>
          ☰
        </div>

        {/* Mobile Navigation (Slide-In Menu) */}
        <div className={`mobile-menu ${isOpen ? "open" : ""}`}>
          {/* Close Button */}
          <div className="close-btn" onClick={() => setIsOpen(false)}>
            ✖
          </div>

          <ul>
            <li><Link to="/product" onClick={() => setIsOpen(false)}>PRODUCT'S</Link></li>
            <li><Link to="/about" onClick={() => setIsOpen(false)}>ABOUT</Link></li>
            <li><Link to="/contact" onClick={() => setIsOpen(false)}>CONTACT</Link></li>
            <li><Link to="/career" onClick={() => setIsOpen(false)}>CAREER</Link></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
